/**
 * Menus, mobile nav, scroll behavior.
 */

function normalizePath( pathname ) {
	return pathname.replace( /\/+$/, '' ) || '/';
}

function getHashTarget( hash ) {
	if ( ! hash || hash === '#' ) {
		return null;
	}

	let id = '';

	try {
		id = decodeURIComponent( hash.replace( /^#/, '' ) );
	} catch ( error ) {
		return null;
	}

	if ( ! id ) {
		return null;
	}

	return document.getElementById( id );
}

function getHeaderBottom() {
	const header = document.querySelector( 'header' );

	if ( ! header ) {
		return 0;
	}

	return Math.ceil( header.getBoundingClientRect().bottom );
}

function scrollToSection( target, behavior ) {
	const top = window.scrollY + target.getBoundingClientRect().top - getHeaderBottom();

	window.scrollTo( {
		top: Math.max( 0, top ),
		behavior,
	} );
}

function scrollToCurrentHash( behavior ) {
	const target = getHashTarget( window.location.hash );

	if ( target ) {
		scrollToSection( target, behavior );
	}
}

function afterLayout( callback ) {
	requestAnimationFrame( () => {
		requestAnimationFrame( callback );
	} );
}

export default function initNavigation() {
	let alignUntil = 0;
	const retryMs = [ 400, 800, 1400, 2200 ];

	const align = ( behavior ) => {
		afterLayout( () => scrollToCurrentHash( behavior ) );
	};

	const startAlign = ( behavior ) => {
		alignUntil = Date.now() + 2500;
		align( behavior );
		retryMs.forEach( ( delay ) => {
			window.setTimeout( () => {
				if ( Date.now() <= alignUntil ) {
					scrollToCurrentHash( 'auto' );
				}
			}, delay );
		} );
	};

	document.addEventListener( 'click', ( event ) => {
		const link = event.target.closest( 'a[href]' );

		if (
			! link ||
			event.defaultPrevented ||
			event.button !== 0 ||
			event.metaKey ||
			event.ctrlKey ||
			event.shiftKey ||
			event.altKey
		) {
			return;
		}

		let url;

		try {
			url = new URL( link.href, window.location.href );
		} catch ( error ) {
			return;
		}

		if ( url.origin !== window.location.origin ) {
			return;
		}

		if ( normalizePath( url.pathname ) !== normalizePath( window.location.pathname ) ) {
			return;
		}

		const target = getHashTarget( url.hash );

		if ( ! target ) {
			return;
		}

		event.preventDefault();

		if ( window.location.hash !== url.hash ) {
			history.pushState( null, '', url.hash );
		}

		startAlign( 'smooth' );
	} );

	if ( document.readyState === 'complete' ) {
		if ( window.location.hash ) {
			startAlign( 'auto' );
		}
	} else {
		window.addEventListener(
			'load',
			() => {
				if ( window.location.hash ) {
					startAlign( 'auto' );
				}
			},
			{ once: true }
		);
	}

	window.addEventListener( 'hashchange', () => startAlign( 'smooth' ) );

	if ( document.fonts && document.fonts.ready ) {
		document.fonts.ready.then( () => {
			if ( window.location.hash ) {
				startAlign( 'auto' );
			}
		} );
	}

	const header = document.querySelector( 'header' );

	if ( header && typeof ResizeObserver !== 'undefined' ) {
		let lastHeight = header.offsetHeight;

		new ResizeObserver( () => {
			const nextHeight = header.offsetHeight;

			if ( nextHeight === lastHeight ) {
				return;
			}

			lastHeight = nextHeight;

			if ( window.location.hash && Date.now() <= alignUntil ) {
				scrollToCurrentHash( 'auto' );
			}
		} ).observe( header );
	}

	const html = document.documentElement;
	new MutationObserver( () => {
		if ( window.location.hash && Date.now() <= alignUntil ) {
			scrollToCurrentHash( 'auto' );
		}
	} ).observe( html, {
		attributes: true,
		attributeFilter: [ 'lang', 'class' ],
	} );
}
